import { RouteFragment } from '../RouteFragment';
import { RouteSearchResults } from './RouteSearchResults';

export class RouteEmpty extends RouteSearchResults {

	public static readonly fragmentType: typeof RouteEmpty = RouteEmpty;

	public constructor() {
		super('Empty');
	}

	protected override selfRoutePath(): string {
		return '';
	}

	public override instantiate(): RouteFragment {
		return new RouteEmpty();
	}

	protected override selfSupports(): Promise<boolean> {
		return Promise.resolve(true);
	}
}
